import { render, staticRenderFns } from "./UsersSection.vue?vue&type=template&id=6f0f20ce&"
import script from "./UsersSection.vue?vue&type=script&lang=js&"
export * from "./UsersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports